import React, { memo, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Portfolio from "../components/PortfolioSection/PortfolioSection";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import OurBrand from "../components/BrandCard/BrandCard";
import OfferCard from "../components/offer-card/OfferCard";
import Fmain, { PropertyPromise } from "../components/fetured-properties/Fmain";
import HeroSection from "../components/hero-card/HeroSection";
import { useGetConstructionDetails, useGetRealEstateDetails } from "src/helperHooks/getDetails";
import construction from "src/components/image/project_42_home.webp";
import realestate from "src/components/image/project_Image_home.webp";

const offerCreds = [
  {
    path: "/construction",
    title: "Construction",
    imageUrl:
      construction,
    description:
      "Homely Buildofiy specializes in providing end-to-end construction solutions for residential, commercial, and industrial projects. From concept to completion, the company ensures meticulous planning, precise execution, and timely delivery.",
  },
  {
    path: "/real-estate",
    title: "Real Estate",
    imageUrl:
     realestate,
    description:
      "Homely Buildofiy is involved in the development of residential, commercial, and mixed-use properties, catering to the evolving needs of urban communities.",
  },
];

const HomePage = ({ setIsFormOpen }) => {
  const history = useHistory();
  const { data } = useGetConstructionDetails();
  const { data: realEstateData, loading } = useGetRealEstateDetails();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box sx={{ backgroundColor: "background.default" }}>
      <HeroSection onEnquire={() => setIsFormOpen(true)} />
      {/* How Homely Works is temporarily hidden while the property-led homepage is in place. */}
      <PropertyPromise data={realEstateData} loading={loading} />
      <Fmain data={realEstateData} loading={loading} />
      <Box
        component="section"
        aria-labelledby="what-we-offer-title"
        sx={{
          mt: { xs: 5, md: 8 },
          px: { xs: 2, sm: 3, md: 5 },
          py: { xs: 5, md: 7 },
          backgroundColor: "#eeece5",
        }}
      >
        <Box
          sx={{
            maxWidth: 1440,
            mx: "auto",
            display: "grid",
            justifyItems: "center",
            textAlign: "center",
            gridTemplateColumns: "1fr",
            rowGap: { xs: 1.5, md: 2 },
            mb: { xs: 3, md: 4 },
          }}
        >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Typography
              component="p"
              sx={{
                mb: 1.5,
                color: "#9a794b",
                fontSize: "0.7rem",
                fontWeight: 600,
                letterSpacing: "0.2em",
              }}
            >
              FROM VISION TO REALITY
            </Typography>
            <Typography
              id="what-we-offer-title"
              component="h2"
              variant="h3"
              sx={{ fontSize: { xs: "2.4rem", md: "3.3rem" }, lineHeight: 1.12 }}
            >
              What We Offer
            </Typography>
          </Box>
          <Typography
            sx={{
              maxWidth: 480,
              color: "text.secondary",
              fontSize: "0.9rem",
              lineHeight: 1.8,
            }}
          >
            From building with care to finding a place of your own, discover how
            Homely can help shape what comes next.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" },
            gap: { xs: 2.5, md: 3 },
            maxWidth: 1440,
            mx: "auto",
          }}
        >
          {offerCreds.map((offer, index) => (
            <OfferCard
              key={offer.path}
              index={index}
              title={offer.title}
              imageUrl={offer.imageUrl}
              description={offer.description}
              redirectPath={offer.path}
            />
          ))}
        </Box>
      </Box>
      <Box sx={{ mt: { xs: 7, md: 11 } }}>
        <Portfolio data={data} onViewAll={() => history.push("/construction")} />
      </Box>
      <Box my={2}>
        <OurBrand />
      </Box>
    </Box>
  );
};

export default memo(HomePage);